// extracted by mini-css-extract-plugin
export var circle = "_ev-1";
export var exitConfirmationModal = "_ev-5";
export var iframe = "_ev-0";
export var offline = "_ev-3";
export var online = "_ev-2";
export var workstationSelectError = "_ev-4";